<eh-spinner></eh-spinner>
<div class="container h-100">
  <div class="row w-75 mx-auto h-100">
    <div class="d-flex rounded-3 h-75 p-0 shadow m-auto">
      <div class="col rounded-start-3 h-100 d-flex flex-column p-5 bg-teal6">
        <img class="m-auto w-75" src="./assets/images/enliven-innovation-logo.png" alt="EnlivenHealth logo" />
      </div>
      <div class="col rounded-end-3 h-100 d-flex flex-column p-5 bg-white overflow-y-auto">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
